const state = () => {
    return {
        inputs: [],
        input: {},
        input_filters: {},
    }
}

export default state;
